<template>
  <b-container>
    <div class="mt-5 pl-4 pr-4 pb-4 bg-white">
      <h1 class="pt-4 pb-4"><strong>Who we address</strong></h1>
      <!--      <p style="text-align: justify">The following are indicative user scenarios showcasing what different users of the-->
      <!--        CultureLabs platform can do with it:</p>-->

      <!--      <p style="text-align: justify">Below, you can find some examples of possible users (indicative personas) of the-->
      <!--        CultureLabs platform and possible ways how the platform may address their needs:-->
      <!--      </p>-->
      <ul style="list-style-type:none;" class="pl-4">
        <div class="row col-12">
          <img class="col-4" style="object-fit: contain; height: 340px" src="../images/Marinella.jpg" alt="">
          <div class="col-8">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/AFeyUH5t1LE" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
          <li style="text-align: justify">
            <p class="container pl-5 pr-5"><strong>Marinella</strong> is a CH professional working at a museum which is a pioneer in
              applying participatory approaches in its institutional practices and has organised many projects targeting
              marginalised groups. She wishes to share the museum's experience with other interested actors, spread
              knowledge about past and future projects, and use services that will help her streamline the museum's
              participatory projects in a more structured and efficient way. Thus, she has the experience to define
              recipes,
              share best practice participatory projects with others and to contribute with resources such as
              participatory
              co-creation methods and project management tools that the museum has used with success. She also wishes to
              discover innovative co-creation and crowdsourcing tools that the museum can experiment with in their
              upcoming
              projects and find collaborators for the museum's upcoming projects. Marinella is, thus, interested in
              uploading resources, creating new recipes, and collaboratively working on them with her colleagues as well
              as
              with external collaborators.
            </p>
          </li>
        </div>
        <!--        <div class="offset-3 col-9">-->
        <!--          <iframe width="560" height="315" src="https://www.youtube.com/embed/AFeyUH5t1LE" frameborder="0"-->
        <!--                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"-->
        <!--                  allowfullscreen></iframe>-->
        <!--        </div>-->
        <hr>
        <div class="row col-12">
          <img class="col-4" style="object-fit: contain; height: 340px" src="../images/Pedro.jpg" alt="">
          <div class="col-8">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/rv2dSw7HyNc" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
          <li class="mt-3" style="text-align: justify">
            <p class="container pl-5 pr-5"><strong>Pedro</strong> is working as a volunteer in an NGO which assists migrants and other
              marginalised groups by offering several types of services, from language courses to providing legal
              assistance. The NGO has been contacted by a local museum in order to collaborate with them in the
              participatory project they are preparing and consult them on how to approach and involve migrants. Pedro
              has
              been invited to co-design together with the museum professionals a project-recipe under development.
              Motivated
              by this collaboration, Pedro seeks to get inspiration from previous similar projects, discover helpful
              material, and adjust recipes created by others so as to serve the needs of the project he is responsible
              for.
            </p>
          </li>
        </div>
        <!--        <div class="offset-3 col-9">-->
        <!--          <iframe width="560" height="315" src="https://www.youtube.com/embed/rv2dSw7HyNc" frameborder="0"-->
        <!--                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"-->
        <!--                  allowfullscreen></iframe>-->
        <!--        </div>-->
        <hr/>
        <div class="row col-12">
          <img class="col-4" style="object-fit: contain; height: 340px" src="../images/Samira.jpg" alt="">
          <div class="col-8">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/LUNobPHxi28" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
          <li class="mt-3" style="text-align: justify">
            <p class="container pl-5 pr-5"><strong>Samira</strong> is a migrant who invests into broader interaction with the host society while at
              the same time is
              aware and proud of the cultural heritage of her country of origin. She is an active member of her
              community and participates in the organisation of feasts and other cultural events together with her
              compatriots. She is interested in finding ways to collaborate with CH institutions and make use of their
              facilities in order to raise awareness about her community's heritage and promote its cultural activities.
              She is also interested in providing ideas to NGOs and public administrations about ways in which her
              community's cultural heritage could be used to promote the integration of those of her compatriots who are
              still facing integration problems. In this course, she is looking for organisations who would be
              interested in her project ideas and willing to support them, organisationally and financially. Based on
              her experience with disadvantaged groups, she is also in the position to provide feedback on the
              organisation of participatory projects and assess existing recipes based on their appropriateness for
              involving marginalised target groups.
            </p>
          </li>
        </div>
        <hr>
        <div class="row col-12">
          <img class="col-4" style="object-fit: contain; height: 340px" src="../images/Claire.jpg" alt="">
          <div class="col-8">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/9hv5KqPtyMw" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
          <li class="mt-3" style="text-align: justify">
            <p class="container pl-5 pr-5"><strong>Claire</strong> is a municipal member of staff responsible for the implementation of
              migrants integration policies at the local level. Confronted with the recent migrant crisis in Europe, the
              municipality seeks to implement specific policies and projects that contribute to the integration of
              migrants
              and to combating xenophobia. Claire wishes to propose some ideas for projects that use interaction with
              cultural heritage as a means to promote the mutual understanding between recently arrived migrants and the
              host society. In this course, she wants to discover useful policies and good practices implemented in
              other
              countries-regions, combine elements of successful recipes created by others, and be able to articulate
              them
              together with her own ideas into new projects-proposals. She also wants to be able to efficiently discuss
              these projects with fellow professionals and get helpful feedback before presenting them in a structured
              way -
              in the form of new recipes - to the responsible committee. To support her proposal, she also wishes to
              draw a
              landscape of organisations in the CH field as well as organisations working with migrants who would be
              interested to collaborate with the municipality to organise together the suggested projects.</p>
          </li>
        </div>
        <hr>
        <div class="row col-12">
          <img class="col-4" style="object-fit: contain; height: 340px" src="../images/Didier.jpg" alt="">
          <div class="col-8">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/e1onLyxJfVg" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
          <li class="mt-3" style="text-align: justify">
            <p class="container pl-5 pr-5"><strong>Didier</strong> is a researcher in sociology who is currently conducting some research on
              the role of CH in the life of different migrants groups and their relation with dominant/institutional
              heritage. In the course of his research, he seeks to access useful relevant resources, such as examples of
              collaborations between community members and institutions, related policies on migration and CH etc. He
              also
              wishes to receive guidance and engage in discussions with CH professionals with experience in the issue
              through an open forum that promotes ideas exchange. He is also in the position to review and assess
              certain
              resources in the platform based on his research experience.</p>
          </li>
        </div>
      </ul>

      <p style="text-align: justify"><strong>User Scenario 1</strong>
        <br><i>Involved personas</i>: Didier (guest user)</p>
      <p style="text-align: justify">Didier, who visits the CultureLabs platform as a guest for the
        first time, is
        looking for policies, studies, and projects that could be helpful for his research on the role of CH in the life
        of different migrants' groups and their relation with dominant/institutional heritage. By browsing on the
        welcome page, he gets a first overview of the kind of objects that can be found on the CultureLabs platform. He
        is first presented with the most popular public resources and recipes highlighted as "best practices" (including
        methodologies, participatory projects etc. that have been deemed as useful by relevant stakeholders who have
        already used them). <br> He views some of the featured objects and decides to search for more useful material.
        He
        first types some quite general keywords, e.g. "migrants'cultural heritage". He browses the returned initial
        set
        of results and uses the available filters to refine his search and make it more focused, e.g. he can limit his
        search for resources of type "Policy about migration" and projects (implemented recipes) on topics
        "Intercultural understanding" and "Social inclusion". <br>Didier is thus able to discover and
        access some useful
        material. He also has a look at the topics discussed in the public forum and decides to write a post by quickly
        signing with his Google account. He can also provide some feedback on the recipes and resources he has read by
        reviewing and rating them and in this way help next newcomers to discover valuable supporting material.
      </p>

      <br>

      <p style="text-align: justify"><strong>User Scenario 2</strong>
        <br><i>Involved personas</i>: Marinella</p>
      <p style="text-align: justify">Marinella is an experienced and active user of the platform who
        has uploaded
        several resources and recipes and has contributed -as a collaborator or as a commentator- to several resources
        shared with her by other users. <br>In her course to discover innovative co-creation and project management
        physical
        and digital tools which can be used in the upcoming projects-recipes to be organised by her museum, she has
        marked several resources she found interesting as "favorites", so as to be able to revisit and reuse them
        easily. <br> The different resources are well-organised under her Workspace (via the use of appropriate
        categories to
        distinguish between "My recipes", "Shared with me", "Favorites" etc) and searchable. <br>Marinella
        uses the recipe
        editor to describe a new participatory project in the form of a recipe, documenting its important parameters
        (e.g. collaborating organisations, target groups etc), steps-activities, and ingredients-helpful material. <br>
        The
        recipe editor guides her through a clear structure, prompts her to describe important aspects of the project via
        free text or by selecting values from predefined lists, and allows her to link certain steps with relevant
        resources from the public repository and her Workspace. She can also upload documents and visual content that is
        helpful for the organisation and implementation of the project activities and link to useful videos.<br>
        After the recipe has taken its final shape, Marinella may decide to make it public, so that other users
        can view it and
        benefit from her experience and the useful material she has uploaded. This publicity is also an excellent way of
        attracting valuable collaborators interested in participating in the planned participatory activities of the
        recipe, which is an important motivation for her to make her recipe public.
      </p>

      <br>

      <p style="text-align: justify"><strong>User Scenario 3</strong>
        <br><i>Involved personas</i>: Samira, Marinella, Pedro, Claire</p>
      <p style="text-align: justify">Samira is exploring the platform's public resources and discovers the recipe
        published by Marinella which is quite close to what his museum wishes to start organising. She thus decides to
        take this recipe as an initial template and adjust it so as to produce a new one, tailored to her own needs.
        <br>
        She starts by making some preliminary modifications, such as editing the collaborators and removing some
        irrelevant steps and ingredients/outcomes. She has also discovered several ingredients and steps from other
        recipes which she wishes to reuse and adds them to the recipe she is preparing.
        <br>
        After having drafted a first version of the project, she searches the platform for organisations working with
        migrants active in her country. She discovers the NGO where Pedro is working and contacts them. Pedro is very
        keen to help Samira on the project, so Samira shares the recipe she has drafted with him, giving him co-edit
        rights so that they can work collaboratively to shape the project into its complete form. Pedro further shares
        the new recipe with view-comment rights with some migrant representatives in order to receive helpful feedback.
        <br>
        Samira receives a notification about the recipe under development and provides her comments on it. After the
        recipe has taken its final form, Samira exports the recipe description into a document which she can present in
        his meeting with Claire, a representative from the municipality, who is collecting ideas for projects about
        migrants' cultural heritage.
      </p>
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'OurUsers.vue'
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/OurUsers.vue